import React from 'react'
import { VictoryChart, VictoryLine, VictoryAxis } from 'victory'
import victoryTheme from 'config/victoryTheme'
import styled from 'react-emotion'
import { Query } from 'react-apollo'
import VARIANCE_GRAPH_QUERY from 'components/VarianceGraph.query'
import Feature from 'components/Feature'

const GraphContainer = styled.div`
  position: relative;
`

const VarianceGraph = ({ theme, video, duration, currentTime }) => (
  <Feature
    name="variance_graph"
    render={() => (
      <Query query={VARIANCE_GRAPH_QUERY} variables={{ videoId: video.id }}>
        {({ loading, data, ...rest }) =>
          loading ? null : (
            <GraphContainer>
              <VictoryChart theme={victoryTheme} height={50} padding={0}>
                <VictoryAxis
                  crossAxis
                  domain={[0, duration]}
                  theme={victoryTheme}
                  style={{ tickLabels: { display: 'none' } }}
                  standalone={false}
                />
                {data.node.fragments.map(
                  ({ startTime, endTime, highlightScore }) => (
                    <VictoryLine
                      style={{
                        data: {
                          stroke: highlightScore > 0 ? '#F21945' : '#428fdb',
                          strokeOpacity: 0.2,
                          strokeWidth: 3
                        }
                      }}
                      data={[
                        {
                          x: startTime,
                          y: highlightScore
                        },
                        {
                          x: endTime,
                          y: highlightScore
                        }
                      ]}
                    />
                  )
                )}
              </VictoryChart>
            </GraphContainer>
          )
        }
      </Query>
    )}
  />
)

export default VarianceGraph



// WEBPACK FOOTER //
// ./src/components/VarianceGraph.js